import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyPersonalSettingsAccessTokensRoute: InvariantJiraRoute = {
	name: 'legacy-personal-settings-access-tokens',
	path: '/plugins/servlet/oauth/users/access-tokens',
};
